import React from 'react'

import { AspectBox, Icon } from '@fourthwall/components'
import { GiftIcon, PlaceholderPhotoIcon } from '@fourthwall/icons'

import * as S from './styled'
import type { PhotoThumbnailProps } from './types'

const placeholderHeightMap: Record<NonNullable<PhotoThumbnailProps['size']>, number> = {
  tiny: 12,
  small: 16,
  medium: 16,
  large: 24,
  extraLarge: 32,
}

export const PhotoThumbnail = ({ url, size = 'medium', type = 'product' }: PhotoThumbnailProps) => {
  const renderPhoto = () => {
    if (!url) {
      const height = placeholderHeightMap[size]

      if (type === 'giftCard') {
        return (
          <S.Placeholder>
            <Icon component={GiftIcon} height={height} />
          </S.Placeholder>
        )
      }

      return (
        <S.Placeholder>
          <Icon component={PlaceholderPhotoIcon} height={height} />
        </S.Placeholder>
      )
    }

    return <S.Image src={url} />
  }

  return (
    <S.Container $size={size}>
      <AspectBox ratio="3:4">{renderPhoto()}</AspectBox>
    </S.Container>
  )
}
